
import OrderDurationProgress from "./order-duration-progress.vue";
import OrderOtpChipMobile from "./order-otp-chip-mobile.vue";
export default {
  props: {
    order: {}
  },
  components: { OrderOtpChipMobile, OrderDurationProgress },
  data() {
    return {
      secondsSincePreparing: 0
    };
  },
  mounted() {
    if (this.isPreparing)
      this.secondsSincePreparing = this.getDateTimeDifferenceInSeconds(
        this.order.accepted_at
      );
  },
  computed: {
    isReadyForDelivery() {
      return (
        this.order.status == this.$constants.OrderStatuses.READY_FOR_DELIVERY.id
      );
    },
    isPreparing() {
      return this.order.status == this.$constants.OrderStatuses.PREPARING.id;
    }
  },
  methods: {
    getOrderId(order) {
      //
      if (order.merchant_ref_id) {
        return String(order.merchant_ref_id).substr(
          String(order.merchant_ref_id).length - 4,
          4
        );
      }
      if (order.partner_order_id) {
        return String(order.partner_order_id).substr(
          String(order.partner_order_id).length - 4,
          4
        );
      }
      return "";
    }
  }
};
